"use client"

import {useIsMobileShell} from "@/hooks/use-mobile";
import {ReactNode} from "react";
import dynamic from "next/dynamic";

interface IProps {
    children: ReactNode;
}

// ui.isMobile is seeded server-side from the User-Agent, so the branch taken
// here is already correct on the server and first client render — only the
// matching shell's chunk is ever fetched. See CLAUDE.md's hydration-safe
// client-only values section for why this doesn't need a mount effect.
const MobileVersion = dynamic(() => import("@/app/components/MobileVersion"));
const DesktopVersion = dynamic(() => import("@/app/components/DesktopVersion"));

export const VersionResolver = ({children}: IProps) => {
    const isMobile = useIsMobileShell();
    return (
        isMobile ? <MobileVersion>{children}</MobileVersion> : <DesktopVersion>{children}</DesktopVersion>
    )
}
